// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import baseURL from "../../authComponents/baseURL/BaseURL";
// import ProfileCard from "../../reusableComponents/ProfileCard";
// import { FaBackward, FaForward } from "react-icons/fa";
// import { toast } from "react-toastify";

// const AllProfiles = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);

//   const [profiles, setProfiles] = useState([]);
//   const [currentCountry, setCurrentCountry] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const profilesPerPage = 12;
//   const [gender, setGender] = useState(searchParams.get("gender") || "");
//   const [marital_status, setMaritalStatus] = useState(
//     searchParams.get("marital_status") || ""
//   );
//   const [religion, setReligion] = useState(searchParams.get("religion") || "");
//   const [occupation, setOccupation] = useState(
//     searchParams.get("occupation") || ""
//   );
//   const [age_min, setAge_min] = useState(searchParams.get("age_min") || "");
//   const [age_max, setAge_max] = useState(searchParams.get("age_max") || "");

//   const [world_country_id, setWorldCountryId] = useState(
//     searchParams.get("world_country_id") || ""
//   );
//   const [world_division_id, setWorldDivisionId] = useState(
//     searchParams.get("world_division_id") || ""
//   );
//   const [world_city_id, setWorldCityId] = useState(
//     searchParams.get("world_city_id") || ""
//   );

//   const [countries, setCountries] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [cities, setCities] = useState([]);

//   const [searchType, setSearchType] = useState(
//     searchParams.get("searchType") || ''
//   );

//   const resetFilters = () => {
//     setGender("");
//     setMaritalStatus("");
//     setReligion("");
//     setOccupation("");
//     setAge_min("");
//     setAge_max("");
//     setWorldCountryId("");
//     setWorldDivisionId("");
//     setWorldCityId("");
//     setDivisions([]);
//     setCities([]);
//   };

//   useEffect(() => {
//     const fetchInitialProfiles = async () => {
//       try {
//         const currentParams = Object.fromEntries(searchParams.entries());
//         const filteredParams = Object.fromEntries(
//           Object.entries(currentParams).filter(([_, v]) => v !== "")
//         );
//         const response = await baseURL.get("/all_profiles", {
//           params: filteredParams,
//         });
//         setProfiles(response.data.data || []);
//         setCurrentCountry(response.data.current_country)
//       } catch (error) {
//         setError("Failed to load profiles.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchInitialProfiles();
//   }, [location.search]);

//   useEffect(() => {
//     const fetchCountries = async () => {
//       try {
//         const response = await baseURL.get("/get_all_countries");
//         setCountries(response.data.countries);
//       } catch (error) {
//         console.error("Error fetching countries:", error);
//         toast.error("Failed to load countries.");
//       }
//     };

//     fetchCountries();
//   }, []);

//   const handleCountryChange = async (e) => {
//     const selectedCountry = e.target.value;
//     setWorldCountryId(selectedCountry);
//     setWorldDivisionId("");
//     setWorldCityId("");
//     setDivisions([]);
//     setCities([]);

//     if (selectedCountry) {
//       try {
//         const response = await baseURL.get(
//           `/get_world_divisions/${selectedCountry}`
//         );
//         setDivisions(response.data.divisions);
//       } catch (error) {
//         console.error("Error fetching divisions:", error);
//         toast.error("Failed to load divisions.");
//       }
//     }
//   };

//   const handleDivisionChange = async (e) => {
//     const selectedDivision = e.target.value;

//     setWorldDivisionId(selectedDivision);
//     setWorldCityId("");
//     setCities([]);

//     if (selectedDivision) {
//       try {
//         const response = await baseURL.get(
//           `/get_all_cities/${selectedDivision}`
//         );
//         setCities(response.data.cities);
//       } catch (error) {
//         console.error("Error fetching cities:", error);
//         toast.error("Failed to load cities.");
//       }
//     }
//   };

//   const handleSearch = async () => {
//     try {
//       setLoading(true);
//       const searchParams = new URLSearchParams();

//       if (searchType) searchParams.set("searchType", searchType);

//       const filters = {
//         gender,
//         marital_status,
//         religion,
//         occupation,
//         age_min,
//         age_max,
//         world_country_id,
//         world_division_id,
//         world_city_id,
//       };
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) searchParams.set(key, value);
//       });
//       navigate(`/all-profiles?${searchParams.toString()}`, { replace: true });
//       const response = await baseURL.get("/all_profiles", {
//         params: Object.fromEntries(searchParams),
//       });
//       setProfiles(response.data.data || []);
//       setCurrentCountry(response.data.current_country)
//       setError(null);
//     } catch (error) {
//       console.error("Error fetching profiles:", error);
//       setError(
//         error.response?.data?.message ||
//         "Failed to load profiles. Please try again later."
//       );
//       toast.error("Failed to load profiles");
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     handleSearch();
//   }, [
//     gender,
//     marital_status,
//     religion,
//     occupation,
//     age_min,
//     age_max,
//     world_country_id,
//     world_division_id,
//     world_city_id,
//     searchType,
//   ]);

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center min-h-screen">
//         <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-[#730000]"></div>
//         <p className="ml-4 text-[#730000] font-bold">Loading Profiles...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="text-center text-red-500 font-extrabold text-2xl min-h-screen mt-20">
//         <p>{error}</p>
//         <button
//           onClick={() => {
//             setError(null);
//           }}
//           className="mt-4 px-4 py-2 bg-[#730000] text-white rounded"
//         >
//           Try Again
//         </button>
//       </div>
//     );
//   }

//   const indexOfLastProfile = currentPage * profilesPerPage;
//   const indexOfFirstProfile = indexOfLastProfile - profilesPerPage;
//   const currentProfiles = profiles.slice(
//     indexOfFirstProfile,
//     indexOfLastProfile
//   );
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const totalPages = Math.ceil(profiles.length / profilesPerPage);
//   return (
//     <div className="p-10 max-md:p-4 min-h-screen">
//       <div className="mb-4">
//         <p className="text-lg font-bold text-[#730000] mb-2">
//           Search Preferences
//         </p>

//         <div className="flex gap-4 mb-4">
//           <button
//             style={{fontFamily: "serif"}}
//             onClick={() => {
//               setSearchType("local");
//               resetFilters();
//             }}
//             className={`px-4 py-2 border rounded ${searchType === "local" ? "bg-[#730000] text-white" : ""
//               }`}
//           >
//             Local Search ( {currentCountry} )
//           </button>
//           <button
//             onClick={() => {
//               setSearchType("international");
//               resetFilters();
//             }}
//             className={`px-4 py-2 border rounded ${searchType === "international" ? "bg-[#730000] text-white" : ""
//               }`}
//           >
//             International Search
//           </button>
//         </div>

//         {/* Conditional Filters */}
//         <div className="flex flex-wrap gap-2 justify-between">
//           {/* "Local" Search Filters */}
//           {searchType === "local" && (
//             <>
//               <select
//                 value={gender}
//                 onChange={(e) => setGender(e.target.value)}
//                 className="px-4 py-2 border rounded w-42"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">I am looking for</option>
//                 <option value="female">Woman</option>
//                 <option value="male">Man</option>
//               </select>
//               <select
//                 value={marital_status}
//                 onChange={(e) => setMaritalStatus(e.target.value)}
//                 className="px-4 py-2 border rounded w-40"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Marital Status</option>
//                 <option value="single">Single</option>
//                 <option value="married">Married</option>
//                 <option value="divorced">Divorced</option>
//                 <option value="separated">Separated</option>
//                 <option value="widow">Widow (Husband Died)</option>
//                 <option value="widower">Widower (Wife Died)</option>
//               </select>
//               <select
//                 value={religion}
//                 onChange={(e) => setReligion(e.target.value)}
//                 className="px-4 py-2 border rounded w-36"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Religion</option>
//                 <option value="islam">Islam</option>
//                 <option value="christianity">Christianity</option>
//                 <option value="hinduism">Hinduism</option>
//                 <option value="buddhism">Buddhism</option>
//                 <option value="sikhism">Sikhism</option>
//                 <option value="jainism">Jainism</option> 
//                 <option value="bahai">Baháʼí Faith</option>
//                 <option value="zoroastrianism">Zoroastrianism</option> 
//                 <option value="confucianism">Confucianism</option>
//                 <option value="taoism">Taoism</option>
//                 <option value="spiritism">Spiritism</option>
//               </select>
//               <select
//                 value={occupation}
//                 onChange={(e) => setOccupation(e.target.value)}
//                 className="px-4 py-2 border rounded w-36"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Profession</option>
//                 <option value="doctor">Doctor</option>
//                 <option value="engineer">Engineer</option>
//                 <option value="css_officer">CSS Officer</option>
//                 <option value="cyber_security">Cyber Security</option>
//                 <option value="teacher">Teacher</option>
//                 <option value="business_man">Business Man</option>
//                 <option value="armed_forces">Armed Forces</option>
//                 <option value="other">Other</option>
//               </select>

//               <select
//                 value={age_min}
//                 onChange={(e) => setAge_min(e.target.value)}
//                 className="px-4 py-2 border rounded w-34"
//                 style={{ fontFamily: "serif", borderColor: 'darkgrey' }}
//               >
//                 <option value="">Min Age</option>
//                 {[...Array(33)].map((_, index) => (
//                   <option key={index} value={18 + index}>
//                     {18 + index}
//                   </option>
//                 ))}
//               </select>
//               <select
//                 value={age_max}
//                 onChange={(e) => setAge_max(e.target.value)}
//                 className="px-4 py-2 border rounded w-34"
//                 style={{ fontFamily: "serif", borderColor: 'darkgrey' }}
//               >
//                 <option value="">Max Age</option>
//                 {[...Array(33)].map((_, index) => (
//                   <option key={index} value={18 + index}>
//                     {18 + index}
//                   </option>
//                 ))}
//               </select>
//             </>
//           )}

//           {/* "International" Search Filters */}
//           {searchType === "international" && (
//             <>
//               <select
//                 value={gender}
//                 onChange={(e) => setGender(e.target.value)}
//                 className="px-4 py-2 border rounded w-42"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">I am looking for</option>
//                 <option value="female">Woman</option>
//                 <option value="male">Man</option>
//               </select>
//               <select
//                 value={marital_status}
//                 onChange={(e) => setMaritalStatus(e.target.value)}
//                 className="px-4 py-2 border rounded w-40"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Marital Status</option>
//                 <option value="single">Single</option>
//                 <option value="married">Married</option>
//                 <option value="divorced">Divorced</option>
//                 <option value="separated">Separated</option>
//                 <option value="widow">Widow (Husband Died)</option>
//                 <option value="widower">Widower (Wife Died)</option>
//               </select>
//               <select
//                 value={religion}
//                 onChange={(e) => setReligion(e.target.value)}
//                 className="px-4 py-2 border rounded w-36"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Religion</option>
//                 <option value="islam">Islam</option>
//                 <option value="christianity">Christianity</option>
//                 <option value="hinduism">Hinduism</option>
//                 <option value="buddhism">Buddhism</option>
//                 <option value="sikhism">Sikhism</option>
//                 <option value="jainism">Jainism</option> 
//                 <option value="bahai">Baháʼí Faith</option>
//                 <option value="zoroastrianism">Zoroastrianism</option> 
//                 <option value="confucianism">Confucianism</option>
//                 <option value="taoism">Taoism</option>
//                 <option value="spiritism">Spiritism</option>
//               </select>
//               <select
//                 value={occupation}
//                 onChange={(e) => setOccupation(e.target.value)}
//                 className="px-4 py-2 border rounded w-36"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Profession</option>
//                 <option value="doctor">Doctor</option>
//                 <option value="engineer">Engineer</option>
//                 <option value="css_officer">CSS Officer</option>
//                 <option value="cyber_security">Cyber Security</option>
//                 <option value="teacher">Teacher</option>
//                 <option value="business_man">Business Man</option>
//                 <option value="armed_forces">Armed Forces</option>
//                 <option value="other">Other</option>
//               </select>
//               {/* First id */}
//               <select
//                 value={world_country_id}
//                 onChange={handleCountryChange}
//                 className="px-4 py-2 border rounded w-36"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Country</option>
//                 {countries.map((country) => (
//                   <option key={country.id} value={country.id}>
//                     {country.name}
//                   </option>
//                 ))}
//               </select>
//               {/* Division Dropdown */}
//               <select
//                 value={world_division_id}
//                 onChange={handleDivisionChange}
//                 className="px-4 py-2 border rounded w-36"
//                 disabled={!world_country_id}
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Division</option>
//                 {divisions.map((division) => (
//                   <option key={division.id} value={division.id}>
//                     {division.name}
//                   </option>
//                 ))}
//               </select>
//               {/* City Dropdown */}
//               <select
//                 value={world_city_id}
//                 onChange={(e) => setWorldCityId(e.target.value)}
//                 className="px-4 py-2 border rounded w-36"
//                 disabled={!world_division_id}
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">City</option>
//                 {cities.map((city) => (
//                   <option key={city.id} value={city.id}>
//                     {city.name}
//                   </option>
//                 ))}
//               </select>
//               <select
//                 value={age_min}
//                 onChange={(e) => setAge_min(e.target.value)}
//                 className="px-4 py-2 border rounded w-34"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Min Age</option>
//                 {[...Array(33)].map((_, index) => (
//                   <option key={index} value={18 + index}>
//                     {18 + index}
//                   </option>
//                 ))}
//               </select>
//               <select
//                 value={age_max}
//                 onChange={(e) => setAge_max(e.target.value)}
//                 className="px-4 py-2 border rounded w-34"
//                 style={{fontFamily: "serif", borderColor: 'darkgrey'}}
//               >
//                 <option value="">Max Age</option>
//                 {[...Array(33)].map((_, index) => (
//                   <option key={index} value={18 + index}>
//                     {18 + index}
//                   </option>
//                 ))}
//               </select>
//             </>
//           )}

//           {/* Search Button */}
//         </div>
//       </div>

//       {/* Pagination Controls */}
//       <div className="flex justify-end mt-10 overflow-x-scrol font-serif">
//         <button
//           onClick={() => paginate(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="px-4 py-2 border rounded-l-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opaworld_city_id-50"
//         >
//           <FaBackward />
//         </button>
//         <div className="">
//           {Array.from({ length: totalPages }, (_, index) => (
//             <button
//               key={index + 1}
//               onClick={() => paginate(index + 1)}
//               className={`px-3 py-2 border-t border-b min-w-10 text-sm font-semibold font-serif ${currentPage === index + 1
//                   ? "bg-[#730000] text-white"
//                   : "bg-white text-[#730000]"
//                 } hover:bg-[#730000] hover:text-white transition duration-200`}
//             >
//               {index + 1}
//             </button>
//           ))}
//         </div>
//         <button
//           onClick={() => paginate(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className="px-4 py-2 border rounded-r-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opaworld_city_id-50"
//         >
//           <FaForward />
//         </button>
//       </div>

//       {/* Profiles Display */}
//       <p className="text-2xl font-bold text-[#730000] mb-2">Profiles</p>
//       <div className="grid grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1 max-md:p-2 justify-start max-sm:text-[10px] gap-6 font-serif">
//       { currentProfiles.length === 0 ? ( 
//             <p>No profiles found for this country. Please use International Search.</p>

//           ) : (
//             currentProfiles.map((profile) => (
//               <ProfileCard key={profile.id} profile={profile} />
//             ))
//           )
//       }
//       </div>

//       {/* Pagination Controls */}
//       <div className="flex justify-end mt-10 overflow-x-scrol font-serif">
//         <button
//           onClick={() => paginate(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="px-4 py-2 border rounded-l-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opaworld_city_id-50"
//         >
//           <FaBackward />
//         </button>
//         <div className="">
//           {Array.from({ length: totalPages }, (_, index) => (
//             <button
//               key={index + 1}
//               onClick={() => paginate(index + 1)}
//               className={`px-3 py-2 border-t border-b min-w-10 text-sm font-semibold font-serif ${currentPage === index + 1
//                   ? "bg-[#730000] text-white"
//                   : "bg-white text-[#730000]"
//                 } hover:bg-[#730000] hover:text-white transition duration-200`}
//             >
//               {index + 1}
//             </button>
//           ))}
//         </div>
//         <button
//           onClick={() => paginate(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className="px-4 py-2 border rounded-r-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opaworld_city_id-50"
//         >
//           <FaForward />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AllProfiles;






















































































// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import baseURL from "../../authComponents/baseURL/BaseURL";
// import ProfileCard from "../../reusableComponents/ProfileCard";
// import { FaBackward, FaForward } from "react-icons/fa";
// import { toast } from "react-toastify";
// import SelectController from "../../reusableComponents/SelectController"; // Import the custom select component

// const AllProfiles = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);

//   const [profiles, setProfiles] = useState([]);
//   const [currentCountry, setCurrentCountry] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const profilesPerPage = 12;
//   const [gender, setGender] = useState(searchParams.get("gender") || "");
//   const [marital_status, setMaritalStatus] = useState(
//     searchParams.get("marital_status") || ""
//   );
//   const [religion, setReligion] = useState(searchParams.get("religion") || "");
//   const [occupation, setOccupation] = useState(
//     searchParams.get("occupation") || ""
//   );
//   const [age_min, setAge_min] = useState(searchParams.get("age_min") || "");
//   const [age_max, setAge_max] = useState(searchParams.get("age_max") || "");

//   const [world_country_id, setWorldCountryId] = useState(
//     searchParams.get("world_country_id") || ""
//   );
//   const [world_division_id, setWorldDivisionId] = useState(
//     searchParams.get("world_division_id") || ""
//   );
//   const [world_city_id, setWorldCityId] = useState(
//     searchParams.get("world_city_id") || ""
//   );

//   const [countries, setCountries] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [cities, setCities] = useState([]);

//   const [isPageChanging, setIsPageChanging] = useState(false);

//   const [searchType, setSearchType] = useState(
//     searchParams.get("searchType") || ''
//   );

//   // Helper to generate age options
//   const generateAgeOptions = () => {
//     const options = [{ value: "", label: "Any" }];
//     for (let i = 18; i <= 50; i++) {
//       options.push({ value: i.toString(), label: i.toString() });
//     }
//     return options;
//   };

//   // Gender options
//   const genderOptions = [
//     { value: "", label: "Any Gender" },
//     { value: "female", label: "Woman" },
//     { value: "male", label: "Man" },
//   ];

//   // Marital status options
//   const maritalStatusOptions = [
//     { value: "", label: "Any" },
//     { value: "single", label: "Single" },
//     { value: "married", label: "Married" },
//     { value: "divorced", label: "Divorced" },
//     { value: "separated", label: "Separated" },
//     { value: "widow", label: "Widow (Husband Died)" },
//     { value: "widower", label: "Widower (Wife Died)" },
//   ];

//   // Religion options
//   const religionOptions = [
//     { value: "", label: "Any" },
//     { value: "islam", label: "Islam" },
//     { value: "christianity", label: "Christianity" },
//     { value: "hinduism", label: "Hinduism" },
//     { value: "buddhism", label: "Buddhism" },
//     { value: "sikhism", label: "Sikhism" },
//     { value: "jainism", label: "Jainism" },
//     { value: "bahai", label: "Baháʼí Faith" },
//     { value: "zoroastrianism", label: "Zoroastrianism" },
//     { value: "confucianism", label: "Confucianism" },
//     { value: "taoism", label: "Taoism" },
//     { value: "spiritism", label: "Spiritism" },
//   ];

//   // Occupation options
//   const occupationOptions = [
//     { value: "", label: "Any" },
//     { value: "accountant", label: "Accountant" },
//     { value: "acting_professional", label: "Acting Professional" },
//     { value: "actor_actress", label: "Actor / Actress" },
//     { value: "administration_professional", label: "Administration Professional" },
//     { value: "advertising_visualiser", label: "Advertising Visualiser" },
//     { value: "air_hostess", label: "Air Hostess" },
//     { value: "architect", label: "Architect" },
//     { value: "artist", label: "Artist" },
//     { value: "audiologist", label: "Audiologist" },
//     { value: "banker", label: "Banker" },
//     { value: "beautician", label: "Beautician" },
//     { value: "biologist", label: "Biologist" },
//     { value: "botanist", label: "Botanist" },
//     { value: "chartered_accountant", label: "Chartered Accountant" },
//     { value: "civil_engineer", label: "Civil Engineer" },
//     { value: "clerical_official", label: "Clerical Official" },
//     { value: "commercial_pilot", label: "Commercial Pilot" },
//     { value: "company_secretary", label: "Company Secretary" },
//     { value: "computer_professional", label: "Computer Professional" },
//     { value: "consultant", label: "Consultant" },
//     { value: "contractor", label: "Contractor" },
//     { value: "cost_accountant", label: "Cost Accountant" },
//     { value: "creative_person", label: "Creative Person" },
//     { value: "customer_support_professional", label: "Customer Support Professional" },
//     { value: "dentist", label: "Dentist" },
//     { value: "designer", label: "Designer" },
//     { value: "doctor", label: "Doctor" },
//     { value: "economist", label: "Economist" },
//     { value: "engineer", label: "Engineer" },
//     { value: "entertainment_professional", label: "Entertainment Professional" },
//     { value: "executive", label: "Executive" },
//     { value: "factory_worker", label: "Factory Worker" },
//     { value: "farmer", label: "Farmer" },
//     { value: "fashion_designer", label: "Fashion Designer" },
//     { value: "finance_professional", label: "Finance Professional" },
//     { value: "flight_attendant", label: "Flight Attendant" },
//     { value: "government_employee", label: "Government Employee" },
//     { value: "health_care_professional", label: "Health Care Professional" },
//     { value: "home_maker", label: "Home Maker" },
//     { value: "hotel_restaurant_professional", label: "Hotel / Restaurant Professional" },
//     { value: "interior_designer", label: "Interior Designer" },
//     { value: "investment_professional", label: "Investment Professional" },
//     { value: "it_telecom_professional", label: "IT / Telecom Professional" },
//     { value: "journalist", label: "Journalist" },
//     { value: "lawyer_legal_professional", label: "Lawyer / Legal Professional" },
//     { value: "manager", label: "Manager" },
//     { value: "marketing_professional", label: "Marketing Professional" },
//     { value: "media_professional", label: "Media Professional" },
//     { value: "medical_professional", label: "Medical Professional" },
//     { value: "military", label: "Military" },
//     { value: "not_working", label: "Not Working" },
//     { value: "nurse", label: "Nurse" },
//     { value: "odd_jobs_part_time", label: "Odd Jobs / Part Time" },
//     { value: "online_merchant", label: "Online Merchant" },
//     { value: "optician", label: "Optician" },
//     { value: "pharmacist", label: "Pharmacist" },
//     { value: "physicist", label: "Physicist" },
//     { value: "physiotherapist", label: "Physiotherapist" },
//     { value: "pilot", label: "Pilot" },
//     { value: "politician", label: "Politician" },
//     { value: "professor_teacher", label: "Professor / Teacher" },
//     { value: "psychologist", label: "Psychologist" },
//     { value: "public_relations_professional", label: "Public Relations Professional" },
//     { value: "real_estate_professional", label: "Real Estate Professional" },
//     { value: "research_scholar", label: "Research Scholar" },
//     { value: "retired_person", label: "Retired Person" },
//     { value: "sales_professional", label: "Sales Professional" },
//     { value: "scientist", label: "Scientist" },
//     { value: "self_employed", label: "Self-Employed" },
//     { value: "social_worker", label: "Social Worker" },
//     { value: "software_consultant", label: "Software Consultant" },
//     { value: "sports_athlete", label: "Sports / Athlete" },
//     { value: "student", label: "Student" },
//     { value: "teacher", label: "Teacher" },
//     { value: "technician", label: "Technician" },
//     { value: "training_professional", label: "Training Professional" },
//     { value: "unspecified", label: "Unspecified" },
//     { value: "veterinary_doctor", label: "Veterinary Doctor" },
//     { value: "volunteer", label: "Volunteer" },
//     { value: "writer", label: "Writer" },
//     { value: "zoologist", label: "Zoologist" },
//   ]

//   const resetFilters = () => {
//     setGender("");
//     setMaritalStatus("");
//     setReligion("");
//     setOccupation("");
//     setAge_min("");
//     setAge_max("");
//     setWorldCountryId("");
//     setWorldDivisionId("");
//     setWorldCityId("");
//     setDivisions([]);
//     setCities([]);
//   };

//   useEffect(() => {
//     const fetchInitialProfiles = async () => {
//       try {
//         const currentParams = Object.fromEntries(searchParams.entries());
//         const filteredParams = Object.fromEntries(
//           Object.entries(currentParams).filter(([_, v]) => v !== "")
//         );
//         const response = await baseURL.get("/all_profiles", {
//           params: filteredParams,
//         });
//         setProfiles(response.data.data || []);
//         setCurrentCountry(response.data.current_country)
//       } catch (error) {
//         setError("Failed to load profiles.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchInitialProfiles();
//   }, [location.search]);

//   useEffect(() => {
//     const fetchCountries = async () => {
//       try {
//         const response = await baseURL.get("/get_all_countries");
//         setCountries(response.data.countries);
//       } catch (error) {
//         console.error("Error fetching countries:", error);
//         toast.error("Failed to load countries.");
//       }
//     };

//     fetchCountries();
//   }, []);

//   const handleCountryChange = async (e) => {
//     const selectedCountry = e.target.value;
//     setWorldCountryId(selectedCountry);
//     setWorldDivisionId("");
//     setWorldCityId("");
//     setDivisions([]);
//     setCities([]);

//     if (selectedCountry) {
//       try {
//         const response = await baseURL.get(
//           `/get_world_divisions/${selectedCountry}`
//         );
//         setDivisions(response.data.divisions);
//       } catch (error) {
//         console.error("Error fetching divisions:", error);
//         toast.error("Failed to load divisions.");
//       }
//     }
//   };

//   const handleDivisionChange = async (e) => {
//     const selectedDivision = e.target.value;

//     setWorldDivisionId(selectedDivision);
//     setWorldCityId("");
//     setCities([]);

//     if (selectedDivision) {
//       try {
//         const response = await baseURL.get(
//           `/get_all_cities/${selectedDivision}`
//         );
//         setCities(response.data.cities);
//       } catch (error) {
//         console.error("Error fetching cities:", error);
//         toast.error("Failed to load cities.");
//       }
//     }
//   };

//   const handleSearch = async () => {
//     try {
//       setLoading(true);
//       const searchParams = new URLSearchParams();

//       if (searchType) searchParams.set("searchType", searchType);

//       const filters = {
//         gender,
//         marital_status,
//         religion,
//         occupation,
//         age_min,
//         age_max,
//         world_country_id,
//         world_division_id,
//         world_city_id,
//       };
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) searchParams.set(key, value);
//       });
//       navigate(`/all-profiles?${searchParams.toString()}`, { replace: true });
//       const response = await baseURL.get("/all_profiles", {
//         params: Object.fromEntries(searchParams),
//       });
//       setProfiles(response.data.data || []);
//       setCurrentCountry(response.data.current_country)
//       setError(null);
//     } catch (error) {
//       console.error("Error fetching profiles:", error);
//       setError(
//         error.response?.data?.message ||
//         "Failed to load profiles. Please try again later."
//       );
//       toast.error("Failed to load profiles");
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     handleSearch();
//   }, [
//     gender,
//     marital_status,
//     religion,
//     occupation,
//     age_min,
//     age_max,
//     world_country_id,
//     world_division_id,
//     world_city_id,
//     searchType,
//   ]);

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center min-h-screen">
//         <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-[#730000]"></div>
//         <p className="ml-4 text-[#730000] font-bold">Loading Profiles...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="text-center text-red-500 font-extrabold text-2xl min-h-screen mt-20">
//         <p>{error}</p>
//         <button
//           onClick={() => {
//             setError(null);
//           }}
//           className="mt-4 px-4 py-2 bg-[#730000] text-white rounded"
//         >
//           Try Again
//         </button>
//       </div>
//     );
//   }

//   const indexOfLastProfile = currentPage * profilesPerPage;
//   const indexOfFirstProfile = indexOfLastProfile - profilesPerPage;
//   const currentProfiles = profiles.slice(
//     indexOfFirstProfile,
//     indexOfLastProfile
//   );
//   // const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const paginate = (pageNumber) => {
//     setIsPageChanging(true);
//     setCurrentPage(pageNumber);

//     // Simulate a brief loading state
//     setTimeout(() => {
//       setIsPageChanging(false);
//     }, 150); // 150ms is enough to show the transition
//   };

//   const totalPages = Math.ceil(profiles.length / profilesPerPage);
//   return (
//     <div className="p-10 max-md:p-4 min-h-screen">
//       <div className="mb-4">
//         <p className="text-lg font-bold text-[#730000] mb-2">
//           Search Preferences
//         </p>

//         <div className="flex gap-4 mb-4 font-swatch">
//           <button
           
//             onClick={() => {
//               setSearchType("local");
//               resetFilters();
//             }}
//             className={`px-4 py-2 border rounded 
//               ${searchType === "local" ? "bg-blue-950 text-white " : "bg-[#730000] text-white"
//               }`}
//           >
//             Local Search ( {currentCountry} )
//           </button>
//           <button
//             onClick={() => {
//               setSearchType("international");
//               resetFilters();
//             }}
//             className={`px-4 py-2 border rounded 
//               ${searchType === "international" ? "bg-blue-950 text-white " : "bg-[#730000] text-white"
//               }`}
//           >
//             International Search
//           </button>
//         </div>

//         {/* Conditional Filters */}
//         <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-2 justify-between">
//           {/* "Local" Search Filters */}
//           {searchType === "local" && (
//             <>
//               <SelectController
//                 label="I am looking for"
//                 name="gender"
//                 value={gender}
//                 onChange={(e) => setGender(e.target.value)}
//                 options={genderOptions}
//                 className="w-42"
//               />

//               <SelectController
//                 label="Marital Status"
//                 name="marital_status"
//                 value={marital_status}
//                 onChange={(e) => setMaritalStatus(e.target.value)}
//                 options={maritalStatusOptions}
//                 className="w-40"
//               />

//               <SelectController
//                 label="Religion"
//                 name="religion"
//                 value={religion}
//                 onChange={(e) => setReligion(e.target.value)}
//                 options={religionOptions}
//                 className="w-36"
//               />

//               <SelectController
//                 label="Profession"
//                 name="occupation"
//                 value={occupation}
//                 onChange={(e) => setOccupation(e.target.value)}
//                 options={occupationOptions}
//                 className="w-36"
//               />

//               <SelectController
//                 label="Min Age"
//                 name="age_min"
//                 value={age_min}
//                 onChange={(e) => setAge_min(e.target.value)}
//                 options={generateAgeOptions("Min Age")}
//                 className="w-34"
//               />

//               <SelectController
//                 label="Max Age"
//                 name="age_max"
//                 value={age_max}
//                 onChange={(e) => setAge_max(e.target.value)}
//                 options={generateAgeOptions("Max Age")}
//                 className="w-34"
//               />
//             </>
//           )}

//           {/* "International" Search Filters */}
//           {searchType === "international" && (
//             <>
//               <SelectController
//                 label="I am looking for"
//                 name="gender"
//                 value={gender}
//                 onChange={(e) => setGender(e.target.value)}
//                 options={genderOptions}
//                 className="w-42"
//               />

//               <SelectController
//                 label="Marital Status"
//                 name="marital_status"
//                 value={marital_status}
//                 onChange={(e) => setMaritalStatus(e.target.value)}
//                 options={maritalStatusOptions}
//                 className="w-40"
//               />

//               <SelectController
//                 label="Religion"
//                 name="religion"
//                 value={religion}
//                 onChange={(e) => setReligion(e.target.value)}
//                 options={religionOptions}
//                 className="w-36"
//               />

//               <SelectController
//                 label="Profession"
//                 name="occupation"
//                 value={occupation}
//                 onChange={(e) => setOccupation(e.target.value)}
//                 options={occupationOptions}
//                 className="w-36"
//               />

//               <SelectController
//                 label="Country"
//                 name="world_country_id"
//                 value={world_country_id}
//                 onChange={handleCountryChange}
//                 options={[
//                   { value: "", label: "Any Country" },
//                   ...countries.map(country => ({
//                     value: country.id,
//                     label: country.name
//                   }))
//                 ]}
//                 className="w-36"
//               />

//               <SelectController
//                 label="Division"
//                 name="world_division_id"
//                 value={world_division_id}
//                 onChange={handleDivisionChange}
//                 options={[
//                   { value: "", label: "Any Division" },
//                   ...divisions.map(division => ({
//                     value: division.id,
//                     label: division.name
//                   }))
//                 ]}
//                 disabled={!world_country_id}
//                 className="w-36"
//               />

//               <SelectController
//                 label="City"
//                 name="world_city_id"
//                 value={world_city_id}
//                 onChange={(e) => setWorldCityId(e.target.value)}
//                 options={[
//                   { value: "", label: "Any City" },
//                   ...cities.map(city => ({
//                     value: city.id,
//                     label: city.name
//                   }))
//                 ]}
//                 disabled={!world_division_id}
//                 className="w-36"
//               />

//               <SelectController
//                 label="Min Age"
//                 name="age_min"
//                 value={age_min}
//                 onChange={(e) => setAge_min(e.target.value)}
//                 options={generateAgeOptions("Min Age")}
//                 className="w-34"
//               />

//               <SelectController
//                 label="Max Age"
//                 name="age_max"
//                 value={age_max}
//                 onChange={(e) => setAge_max(e.target.value)}
//                 options={generateAgeOptions("Max Age")}
//                 className="w-34"
//               />
//             </>
//           )}
//         </div>
//       </div>

//       {/* Pagination Controls */}
//       <div className="flex justify-end mt-10 overflow-x-scrol font-serif">
//         <button
//           onClick={() => paginate(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="px-4 py-2 border rounded-l-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opacity-50"
//         >
//           <FaBackward />
//         </button>
//         <div className="">
//           {Array.from({ length: totalPages }, (_, index) => (
//             <button
//               key={index + 1}
//               onClick={() => paginate(index + 1)}
//               className={`px-3 py-2 border-t border-b min-w-10 text-sm font-semibold font-serif ${currentPage === index + 1
//                 ? "bg-[#730000] text-white"
//                 : "bg-white text-[#730000]"
//                 } hover:bg-[#730000] hover:text-white transition duration-200`}
//             >
//               {index + 1}
//             </button>
//           ))}
//         </div>
//         <button
//           onClick={() => paginate(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className="px-4 py-2 border rounded-r-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opacity-50"
//         >
//           <FaForward />
//         </button>
//       </div>

//       {/* Profiles Display */}
//       <p className="text-2xl font-bold text-[#730000] mb-2">Profiles</p>

//       {isPageChanging ? (
//         <div className="flex justify-center items-center h-64">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-[#730000]"></div>
//         </div>
//       ) : (
//         <div className="grid grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1 max-md:p-2 justify-start max-sm:text-[10px] gap-6 font-serif">
//           {currentProfiles.length === 0 ? (
//             <p>No profiles found for this country. Please use International Search.</p>
//           ) : (
//             currentProfiles.map((profile) => (
//               <ProfileCard key={profile.id} profile={profile} />
//             ))
//           )}
//         </div>
//       )}

//       {/* Pagination Controls */}
//       <div className="flex justify-end mt-10 overflow-x-scrol font-serif">
//         <button
//           onClick={() => paginate(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="px-4 py-2 border rounded-l-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opacity-50"
//         >
//           <FaBackward />
//         </button>
//         <div className="">
//           {Array.from({ length: totalPages }, (_, index) => (
//             <button
//               key={index + 1}
//               onClick={() => paginate(index + 1)}
//               className={`px-3 py-2 border-t border-b min-w-10 text-sm font-semibold font-serif ${currentPage === index + 1
//                 ? "bg-[#730000] text-white"
//                 : "bg-white text-[#730000]"
//                 } hover:bg-[#730000] hover:text-white transition duration-200`}
//             >
//               {index + 1}
//             </button>
//           ))}
//         </div>
//         <button
//           onClick={() => paginate(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className="px-4 py-2 border rounded-r-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opacity-50"
//         >
//           <FaForward />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AllProfiles;







import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import baseURL from "../../authComponents/baseURL/BaseURL";
import ProfileCard from "../../reusableComponents/ProfileCard";
import { FaBackward, FaForward } from "react-icons/fa";
import { toast } from "react-toastify";
import SelectController from "../../reusableComponents/SelectController";

const AllProfiles = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [profiles, setProfiles] = useState([]);
  const [currentCountry, setCurrentCountry] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const profilesPerPage = 12;
  const [gender, setGender] = useState(searchParams.get("gender") || "");
  const [marital_status, setMaritalStatus] = useState(
    searchParams.get("marital_status") || ""
  );
  const [religion, setReligion] = useState(searchParams.get("religion") || "");
  const [occupation, setOccupation] = useState(
    searchParams.get("occupation") || ""
  );
  const [age_min, setAge_min] = useState(searchParams.get("age_min") || "");
  const [age_max, setAge_max] = useState(searchParams.get("age_max") || "");

  const [world_country_id, setWorldCountryId] = useState(
    searchParams.get("world_country_id") || ""
  );
  const [world_division_id, setWorldDivisionId] = useState(
    searchParams.get("world_division_id") || ""
  );
  const [world_city_id, setWorldCityId] = useState(
    searchParams.get("world_city_id") || ""
  );

  const [countries, setCountries] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [cities, setCities] = useState([]);

  const [isPageChanging, setIsPageChanging] = useState(false);

  const [searchType, setSearchType] = useState(
    searchParams.get("searchType") || ''
  );

  // Smart pagination function
  const generatePaginationNumbers = (currentPage, totalPages) => {
    const pages = [];
    
    if (totalPages <= 3) {
      // If total pages are 3 or less, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Logic for more than 3 pages
      if (currentPage <= 2) {
        // Show: 1, 2, 3, ...
        pages.push(1, 2, 3, '...');
      } else if (currentPage >= totalPages - 1) {
        // Show: ..., (totalPages-2), (totalPages-1), totalPages
        pages.push('...', totalPages - 2, totalPages - 1, totalPages);
      } else {
        // Show: ..., (currentPage-1), currentPage, (currentPage+1), ...
        pages.push('...', currentPage - 1, currentPage, currentPage + 1, '...');
      }
    }
    
    return pages;
  };

  // Helper to generate age options
  const generateAgeOptions = () => {
    const options = [{ value: "", label: "Any" }];
    for (let i = 18; i <= 50; i++) {
      options.push({ value: i.toString(), label: i.toString() });
    }
    return options;
  };

  // Gender options
  const genderOptions = [
    { value: "", label: "Any Gender" },
    { value: "female", label: "Woman" },
    { value: "male", label: "Man" },
  ];

  // Marital status options
  const maritalStatusOptions = [
    { value: "", label: "Any" },
    { value: "single", label: "Single" },
    { value: "married", label: "Married" },
    { value: "divorced", label: "Divorced" },
    { value: "separated", label: "Separated" },
    { value: "widow", label: "Widow (Husband Died)" },
    { value: "widower", label: "Widower (Wife Died)" },
  ];

  // Religion options
  const religionOptions = [
    { value: "", label: "Any" },
    { value: "islam", label: "Islam" },
    { value: "christianity", label: "Christianity" },
    { value: "hinduism", label: "Hinduism" },
    { value: "buddhism", label: "Buddhism" },
    { value: "sikhism", label: "Sikhism" },
    { value: "jainism", label: "Jainism" },
    { value: "bahai", label: "Baháʼí Faith" },
    { value: "zoroastrianism", label: "Zoroastrianism" },
    { value: "confucianism", label: "Confucianism" },
    { value: "taoism", label: "Taoism" },
    { value: "spiritism", label: "Spiritism" },
  ];

  // Occupation options
  const occupationOptions = [
    { value: "", label: "Any" },
    { value: "accountant", label: "Accountant" },
    { value: "acting_professional", label: "Acting Professional" },
    { value: "actor_actress", label: "Actor / Actress" },
    { value: "administration_professional", label: "Administration Professional" },
    { value: "advertising_visualiser", label: "Advertising Visualiser" },
    { value: "air_hostess", label: "Air Hostess" },
    { value: "architect", label: "Architect" },
    { value: "artist", label: "Artist" },
    { value: "audiologist", label: "Audiologist" },
    { value: "banker", label: "Banker" },
    { value: "beautician", label: "Beautician" },
    { value: "biologist", label: "Biologist" },
    { value: "botanist", label: "Botanist" },
    { value: "chartered_accountant", label: "Chartered Accountant" },
    { value: "civil_engineer", label: "Civil Engineer" },
    { value: "clerical_official", label: "Clerical Official" },
    { value: "commercial_pilot", label: "Commercial Pilot" },
    { value: "company_secretary", label: "Company Secretary" },
    { value: "computer_professional", label: "Computer Professional" },
    { value: "consultant", label: "Consultant" },
    { value: "contractor", label: "Contractor" },
    { value: "cost_accountant", label: "Cost Accountant" },
    { value: "creative_person", label: "Creative Person" },
    { value: "customer_support_professional", label: "Customer Support Professional" },
    { value: "dentist", label: "Dentist" },
    { value: "designer", label: "Designer" },
    { value: "doctor", label: "Doctor" },
    { value: "economist", label: "Economist" },
    { value: "engineer", label: "Engineer" },
    { value: "entertainment_professional", label: "Entertainment Professional" },
    { value: "executive", label: "Executive" },
    { value: "factory_worker", label: "Factory Worker" },
    { value: "farmer", label: "Farmer" },
    { value: "fashion_designer", label: "Fashion Designer" },
    { value: "finance_professional", label: "Finance Professional" },
    { value: "flight_attendant", label: "Flight Attendant" },
    { value: "government_employee", label: "Government Employee" },
    { value: "health_care_professional", label: "Health Care Professional" },
    { value: "home_maker", label: "Home Maker" },
    { value: "hotel_restaurant_professional", label: "Hotel / Restaurant Professional" },
    { value: "interior_designer", label: "Interior Designer" },
    { value: "investment_professional", label: "Investment Professional" },
    { value: "it_telecom_professional", label: "IT / Telecom Professional" },
    { value: "journalist", label: "Journalist" },
    { value: "lawyer_legal_professional", label: "Lawyer / Legal Professional" },
    { value: "manager", label: "Manager" },
    { value: "marketing_professional", label: "Marketing Professional" },
    { value: "media_professional", label: "Media Professional" },
    { value: "medical_professional", label: "Medical Professional" },
    { value: "military", label: "Military" },
    { value: "not_working", label: "Not Working" },
    { value: "nurse", label: "Nurse" },
    { value: "odd_jobs_part_time", label: "Odd Jobs / Part Time" },
    { value: "online_merchant", label: "Online Merchant" },
    { value: "optician", label: "Optician" },
    { value: "pharmacist", label: "Pharmacist" },
    { value: "physicist", label: "Physicist" },
    { value: "physiotherapist", label: "Physiotherapist" },
    { value: "pilot", label: "Pilot" },
    { value: "politician", label: "Politician" },
    { value: "professor_teacher", label: "Professor / Teacher" },
    { value: "psychologist", label: "Psychologist" },
    { value: "public_relations_professional", label: "Public Relations Professional" },
    { value: "real_estate_professional", label: "Real Estate Professional" },
    { value: "research_scholar", label: "Research Scholar" },
    { value: "retired_person", label: "Retired Person" },
    { value: "sales_professional", label: "Sales Professional" },
    { value: "scientist", label: "Scientist" },
    { value: "self_employed", label: "Self-Employed" },
    { value: "social_worker", label: "Social Worker" },
    { value: "software_consultant", label: "Software Consultant" },
    { value: "sports_athlete", label: "Sports / Athlete" },
    { value: "student", label: "Student" },
    { value: "teacher", label: "Teacher" },
    { value: "technician", label: "Technician" },
    { value: "training_professional", label: "Training Professional" },
    { value: "unspecified", label: "Unspecified" },
    { value: "veterinary_doctor", label: "Veterinary Doctor" },
    { value: "volunteer", label: "Volunteer" },
    { value: "writer", label: "Writer" },
    { value: "zoologist", label: "Zoologist" },
  ];

  const resetFilters = () => {
    setGender("");
    setMaritalStatus("");
    setReligion("");
    setOccupation("");
    setAge_min("");
    setAge_max("");
    setWorldCountryId("");
    setWorldDivisionId("");
    setWorldCityId("");
    setDivisions([]);
    setCities([]);
    setCurrentPage(1)
  };

  useEffect(() => {
    const fetchInitialProfiles = async () => {
      try {
        const currentParams = Object.fromEntries(searchParams.entries());
        const filteredParams = Object.fromEntries(
          Object.entries(currentParams).filter(([_, v]) => v !== "")
        );
        const response = await baseURL.get("/all_profiles", {
          params: filteredParams,
        });
        setProfiles(response.data.data || []);
        setCurrentCountry(response.data.current_country);
      } catch (error) {
        setError("Failed to load profiles.");
      } finally {
        setLoading(false);
        setCurrentPage(1)
      }
    };

    fetchInitialProfiles();
  }, [location.search]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await baseURL.get("/get_all_countries");
        setCountries(response.data.countries);
      } catch (error) {
        console.error("Error fetching countries:", error);
        toast.error("Failed to load countries.");
      }
    };

    fetchCountries();
  }, []);

  const handleCountryChange = async (e) => {
    const selectedCountry = e.target.value;
    setWorldCountryId(selectedCountry);
    setWorldDivisionId("");
    setWorldCityId("");
    setDivisions([]);
    setCities([]);

    if (selectedCountry) {
      try {
        const response = await baseURL.get(
          `/get_world_divisions/${selectedCountry}`
        );
        setDivisions(response.data.divisions);
      } catch (error) {
        console.error("Error fetching divisions:", error);
        toast.error("Failed to load divisions.");
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivision = e.target.value;

    setWorldDivisionId(selectedDivision);
    setWorldCityId("");
    setCities([]);

    if (selectedDivision) {
      try {
        const response = await baseURL.get(
          `/get_all_cities/${selectedDivision}`
        );
        setCities(response.data.cities);
      } catch (error) {
        console.error("Error fetching cities:", error);
        toast.error("Failed to load cities.");
      }
    }
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      const searchParams = new URLSearchParams();

      if (searchType) searchParams.set("searchType", searchType);

      const filters = {
        gender,
        marital_status,
        religion,
        occupation,
        age_min,
        age_max,
        world_country_id,
        world_division_id,
        world_city_id,
      };
      Object.entries(filters).forEach(([key, value]) => {
        if (value) searchParams.set(key, value);
      });
      navigate(`/all-profiles?${searchParams.toString()}`, { replace: true });
      const response = await baseURL.get("/all_profiles", {
        params: Object.fromEntries(searchParams),
      });
      setProfiles(response.data.data || []);
      setCurrentCountry(response.data.current_country);
      setError(null);
    } catch (error) {
      console.error("Error fetching profiles:", error);
      setError(
        error.response?.data?.message ||
        "Failed to load profiles. Please try again later."
      );
      toast.error("Failed to load profiles");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [
    gender,
    marital_status,
    religion,
    occupation,
    age_min,
    age_max,
    world_country_id,
    world_division_id,
    world_city_id,
    searchType,
  ]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-[#730000]"></div>
        <p className="ml-4 text-[#730000] font-bold">Loading Profiles...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-red-500 font-extrabold text-2xl min-h-screen mt-20">
        <p>{error}</p>
        <button
          onClick={() => {
            setError(null);
          }}
          className="mt-4 px-4 py-2 bg-[#730000] text-white rounded"
        >
          Try Again
        </button>
      </div>
    );
  }

  const indexOfLastProfile = currentPage * profilesPerPage;
  const indexOfFirstProfile = indexOfLastProfile - profilesPerPage;
  const currentProfiles = profiles.slice(
    indexOfFirstProfile,
    indexOfLastProfile
  );

  const paginate = (pageNumber) => {
    setIsPageChanging(true);
    setCurrentPage(pageNumber);

    // Simulate a brief loading state
    setTimeout(() => {
      setIsPageChanging(false);
    }, 150); // 150ms is enough to show the transition
  };

  const totalPages = Math.ceil(profiles.length / profilesPerPage);
  const paginationNumbers = generatePaginationNumbers(currentPage, totalPages);

  // Pagination component
  const PaginationControls = () => (
    <div className="flex justify-end mt-10 overflow-x-auto font-serif">
      <button
        onClick={() => paginate(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-4 py-2 border rounded-l-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opacity-50"
      >
        <FaBackward />
      </button>
      
      <div className="flex">
        {paginationNumbers.map((pageNum, index) => (
          pageNum === '...' ? (
            <span
              key={`ellipsis-${index}`}
              className="px-3 py-2 border-t border-b min-w-10 text-sm font-semibold font-serif text-[#730000] bg-white cursor-default"
            >
              ...
            </span>
          ) : (
            <button
              key={pageNum}
              onClick={() => paginate(pageNum)}
              className={`px-3 py-2 border-t border-b min-w-10 text-sm font-semibold font-serif ${
                currentPage === pageNum
                  ? "bg-[#730000] text-white"
                  : "bg-white text-[#730000]"
              } hover:bg-[#730000] hover:text-white transition duration-200`}
            >
              {pageNum}
            </button>
          )
        ))}
      </div>
      
      <button
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-4 py-2 border rounded-r-lg text-[#730000] hover:bg-[#730000] hover:text-white disabled:opacity-50"
      >
        <FaForward />
      </button>
    </div>
  );

  return (
    <div className="p-10 max-md:p-4 min-h-screen">
      <div className="mb-4">
        <p className="text-lg font-bold text-[#730000] mb-2">
          Search Preferences
        </p>

        <div className="flex gap-4 mb-4 font-swatch">
          <button
            onClick={() => {
              setSearchType("local");
              resetFilters();
  
            }}
            className={`px-4 py-2 border rounded 
              ${searchType === "local" ? "bg-blue-950 text-white " : "bg-[#730000] text-white"
              }`}
          >
            Local Search ( {currentCountry} )
          </button>
          <button
            onClick={() => {
              setSearchType("international");
              resetFilters();
    
            }}
            className={`px-4 py-2 border rounded 
              ${searchType === "international" ? "bg-blue-950 text-white " : "bg-[#730000] text-white"
              }`}
          >
            International Search
          </button>
        </div>

        {/* Conditional Filters */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-2 justify-between">
          {/* "Local" Search Filters */}
          {searchType === "local" && (
            <>
              <SelectController
                label="I am looking for"
                name="gender"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                options={genderOptions}
                className="w-42"
              />

              <SelectController
                label="Marital Status"
                name="marital_status"
                value={marital_status}
                onChange={(e) => setMaritalStatus(e.target.value)}
                options={maritalStatusOptions}
                className="w-40"
              />

              <SelectController
                label="Religion"
                name="religion"
                value={religion}
                onChange={(e) => setReligion(e.target.value)}
                options={religionOptions}
                className="w-36"
              />

              <SelectController
                label="Profession"
                name="occupation"
                value={occupation}
                onChange={(e) => setOccupation(e.target.value)}
                options={occupationOptions}
                className="w-36"
              />

              <SelectController
                label="Min Age"
                name="age_min"
                value={age_min}
                onChange={(e) => setAge_min(e.target.value)}
                options={generateAgeOptions("Min Age")}
                className="w-34"
              />

              <SelectController
                label="Max Age"
                name="age_max"
                value={age_max}
                onChange={(e) => setAge_max(e.target.value)}
                options={generateAgeOptions("Max Age")}
                className="w-34"
              />
            </>
          )}

          {/* "International" Search Filters */}
          {searchType === "international" && (
            <>
              <SelectController
                label="I am looking for"
                name="gender"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                options={genderOptions}
                className="w-42"
              />

              <SelectController
                label="Marital Status"
                name="marital_status"
                value={marital_status}
                onChange={(e) => setMaritalStatus(e.target.value)}
                options={maritalStatusOptions}
                className="w-40"
              />

              <SelectController
                label="Religion"
                name="religion"
                value={religion}
                onChange={(e) => setReligion(e.target.value)}
                options={religionOptions}
                className="w-36"
              />

              <SelectController
                label="Profession"
                name="occupation"
                value={occupation}
                onChange={(e) => setOccupation(e.target.value)}
                options={occupationOptions}
                className="w-36"
              />

              <SelectController
                label="Country"
                name="world_country_id"
                value={world_country_id}
                onChange={handleCountryChange}
                options={[
                  { value: "", label: "Any Country" },
                  ...countries.map(country => ({
                    value: country.id,
                    label: country.name
                  }))
                ]}
                className="w-36"
              />

              <SelectController
                label="Division"
                name="world_division_id"
                value={world_division_id}
                onChange={handleDivisionChange}
                options={[
                  { value: "", label: "Any Division" },
                  ...divisions.map(division => ({
                    value: division.id,
                    label: division.name
                  }))
                ]}
                disabled={!world_country_id}
                className="w-36"
              />

              <SelectController
                label="City"
                name="world_city_id"
                value={world_city_id}
                onChange={(e) => setWorldCityId(e.target.value)}
                options={[
                  { value: "", label: "Any City" },
                  ...cities.map(city => ({
                    value: city.id,
                    label: city.name
                  }))
                ]}
                disabled={!world_division_id}
                className="w-36"
              />

              <SelectController
                label="Min Age"
                name="age_min"
                value={age_min}
                onChange={(e) => setAge_min(e.target.value)}
                options={generateAgeOptions("Min Age")}
                className="w-34"
              />

              <SelectController
                label="Max Age"
                name="age_max"
                value={age_max}
                onChange={(e) => setAge_max(e.target.value)}
                options={generateAgeOptions("Max Age")}
                className="w-34"
              />
            </>
          )}
        </div>
      </div>

      {/* Pagination Controls - Top */}
      {totalPages > 1 && <PaginationControls />}

      {/* Profiles Display */}
      <p className="text-2xl font-bold text-[#730000] mb-2">Profiles</p>

      {isPageChanging ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-[#730000]"></div>
        </div>
      ) : (
        <div className="grid grid-cols-3 max-md:grid-cols-2 max-sm:grid-cols-1 max-md:p-2 justify-start max-sm:text-[10px] gap-6 font-serif">
          {currentProfiles.length === 0 ? (
            <p>No profiles found for this country. Please use International Search.</p>
          ) : (
            currentProfiles.map((profile) => (
              <ProfileCard key={profile.id} profile={profile} />
            ))
          )}
        </div>
      )}

      {/* Pagination Controls - Bottom */}
      {totalPages > 1 && <PaginationControls />}
    </div>
  );
};

export default AllProfiles;